import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getEmployeeCredits } from '../../services/marketing';
import useGetMarketingData from './useGetMarketingData';
import { getAccessLevel } from '../../helpers/marketing';

interface Options {
  enabled?: boolean;
}

function useGetEmployeeCredits({ enabled: enabledProp = true }: Options = {}) {
  const { user } = useUser();
  const { data: marketingData } = useGetMarketingData();

  const accessLevel = getAccessLevel(user);

  const enabled =
    !!marketingData?.id &&
    !!user?.userId &&
    !!user?.business?.id &&
    accessLevel === 'self' &&
    enabledProp;

  const { data, isLoading, isFetching, isError, error, refetch, isSuccess } =
    useQuery({
      queryKey: ['employee-credits', user?.userId, marketingData?.id],
      queryFn: () => getEmployeeCredits(marketingData?.id!),
      enabled,
    });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isSuccess,
  };
}

export default useGetEmployeeCredits;
